<script lang="ts" setup>
import {ref, watch} from 'vue'

const props = defineProps<{
  value?: string
}>()

// const emit = defineEmits<{
//   'csv-updated': [csvText: string]
// }>()
const emit = defineEmits(['csv-updated']) // typed version of defineEmits doesn't work in 2.7

const csvText = ref(props.value || '')
const fileName = ref<string | null>(null)
const isDragOver = ref(false)

// Sync external value changes into the textarea
watch(() => props.value, (newVal) => {
  if (newVal !== undefined && newVal !== csvText.value) {
    csvText.value = newVal
    fileName.value = null
  }
})

function handleTextInput() {
  fileName.value = null
  emit('csv-updated', csvText.value)
}

function handleFileChange(event: Event) {
  const target = event.target as HTMLInputElement
  const file = target.files?.[0]
  if (!file) return

  fileName.value = file.name
  const reader = new FileReader()
  reader.onload = () => {
    csvText.value = reader.result as string
    emit('csv-updated', csvText.value)
  }
  reader.readAsText(file)
}

function handleDrop(event: DragEvent) {
  event.preventDefault()
  isDragOver.value = false
  const file = event.dataTransfer?.files?.[0]
  if (!file) return

  fileName.value = file.name
  const reader = new FileReader()
  reader.onload = () => {
    csvText.value = reader.result as string
    emit('csv-updated', csvText.value)
  }
  reader.readAsText(file)
}

function handleDragOver(event: DragEvent) {
  event.preventDefault()
  isDragOver.value = true
}

function handleDragLeave() {
  isDragOver.value = false
}

function clear() {
  csvText.value = ''
  fileName.value = null
  emit('csv-updated', '')
}

defineExpose({clear})
</script>

<template>
  <div
    class="csv-input-wrapper"
    :class="{ 'drag-over': isDragOver }"
    @dragover="handleDragOver"
    @dragleave="handleDragLeave"
    @drop="handleDrop"
  >
    <textarea
      v-model="csvText"
      class="form-control"
      rows="6"
      :placeholder="'email,first_name,last_name,user_type,grade_level,school_id\njane@school.edu,Jane,Doe,teacher,3,42\nbob@test.com,Bob,Smith,school_admin,,'"
      @input="handleTextInput"
    />
    <div class="file-upload-row">
      <input
        type="file"
        accept="text/csv,.csv"
        class="form-control-file"
        @change="handleFileChange"
      />
      <span v-if="fileName" class="file-name">{{ fileName }}</span>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.csv-input-wrapper {
  border: 2px dashed #dee2e6;
  border-radius: 4px;
  padding: 1rem;
  transition: border-color 0.2s;
}

.csv-input-wrapper.drag-over {
  border-color: #007bff;
  background-color: rgba(0, 123, 255, 0.05);
}

.file-upload-row {
  margin-top: 0.75rem;
}

.file-name {
  margin-left: 0.75rem;
  color: #6c757d;
  font-size: 0.875rem;
}
</style>
